import { QueryClient } from '@tanstack/react-query';

// Create a client with default options
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time: how long data is considered fresh (increased for better caching)
      staleTime: 1000 * 60 * 10, // 10 minutes
      // Cache time: how long unused/inactive cache data remains in memory
      gcTime: 1000 * 60 * 60, // 1 hour (formerly cacheTime)
      // Retry failed requests
      retry: 1,
      // Don't refetch on window focus to avoid unnecessary API calls
      refetchOnWindowFocus: false,
      // Don't refetch on mount if data is fresh
      refetchOnMount: false,
      // Don't refetch on reconnect if data is fresh
      refetchOnReconnect: false,
    },
    mutations: {
      // Retry failed mutations
      retry: 1,
    },
  },
});
